<template lang="pug">
  v-row.fill-height.ma-0(align="center" justify="center")
      v-progress-circular(indeterminate :color="color")
</template>

<script>
export default {
  name: 'ImageLoading',
  props: {
    color: {
      type: String,
      default: 'grey darken-5',
    },
  },
};
</script>
